module.exports = __webpack_public_path__ + "static/media/info-icon.b5d5f30a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/info-icon.svg
// module id = 2435
// module chunks = 0